import { ListboxDesignTokens } from '@primeuix/themes/types/listbox';

export const listboxPreset: ListboxDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  colorScheme: {
    dark: {
      root: {
        borderColor: '{nspSlate.500}',
        background: 'var(--background-default)',
        color: '{nspSlate.0}',
      },
      option: {
        color: '{nspSlate.0}',
        focusBackground: '{nspSky.300}',
        focusColor: '{nspSlate.950}',
        selectedBackground: '{nspSky.300}',
        selectedColor: '{nspSlate.950}',
        selectedFocusBackground: '{nspSky.300}',
        selectedFocusColor: '{nspSlate.950}',
      },
    },
    light: {
      root: {
        borderColor: '{nspSlate.0}',
        background: '{nspSlate.0}',
        color: '{nspMist.900}',
      },
      option: {
        color: '{nspSlate.950}',
        focusBackground: '{nspSky.300}',
        focusColor: '{nspSlate.950}',
        selectedBackground: '{nspSky.300}',
        selectedColor: '{nspSlate.950}',
        selectedFocusBackground: '{nspSky.300}',
        selectedFocusColor: '{nspSlate.950}',
      },
    },
  },
};
